import React from 'react';
import { Link } from 'react-router-dom';


const ReviewSection = ({ content }) => {
  return (
    <section className="review-section section-banner">
      <div className="container">
        <div className="inner-content">
          <div className="content-wrapper">
            <h2>{content.title}</h2>
            <p>{content.paragraph}</p>
          <div className='btn-wrap'>
              <Link to={content.linkUrl}>{content.linkText}</Link>
          </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReviewSection;
